import ApiService from './api.service';

// BE resource REST = `material-requisitions` (MRQ — Phiếu yêu cầu vật tư, SO-006).
// Response BE chuẩn hóa: { status, statusCode, message, data } — FE đọc `data`.
const BASE_URL = 'material-requisitions';

/**
 * MaterialRequisitionService — wrapper quanh BE module MRQ (SO-006).
 * BE controller: backend/src/modules/service-order/controllers/material-requisition.controller.ts
 *
 * Luồng: tạo (PENDING, SO→PENDING_PARTS) → phát (ISSUED, trừ tồn) → KTV hoàn dư → (Phase 5: SO SETTLED
 * → CLOSED). Tạo MRQ đợt 2 khi SO đã PENDING_PARTS/PARTS_ISSUED (TR-7/TR-8).
 */
export const MaterialRequisitionService = {
  /**
   * Danh sách MRQ theo phiếu dịch vụ (mới nhất đầu).
   * @param {string} serviceOrderId
   */
  listByServiceOrder(serviceOrderId) {
    return ApiService.query(BASE_URL, { params: { serviceOrderId } });
  },

  /**
   * Chi tiết 1 MRQ + dòng vật tư.
   * @param {string} id
   */
  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },

  /**
   * Lịch sử thao tác 1 MRQ (snapshot originalValue/newValue, mới nhất đầu).
   * @param {string} id
   */
  getHistory(id) {
    return ApiService.query(`${BASE_URL}/${id}/history`);
  },

  /**
   * Tạo MRQ (SO-006 AC-01). SO REPAIRING → PENDING_PARTS (lần đầu); đợt 2 không đổi status SO.
   * @param {Object} data { serviceOrderId, storeId, description?, lines:[{ productId, requestedQuantity, note? }] }
   */
  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  /**
   * Phát vật tư (PENDING → ISSUED). Phát một phần được phép. BE trừ tồn (pessimistic) + snapshot giá vốn.
   * @param {string} id
   * @param {Array} lines [{ detailId, issuedQuantity }]
   */
  issue(id, lines) {
    return ApiService.post(`${BASE_URL}/${id}/issue`, { lines });
  },

  /**
   * KTV hoàn vật tư dư (ISSUED, nhiều lần). Cộng dồn returnedQty ≤ issuedQty.
   * @param {string} id
   * @param {Array} lines [{ detailId, returnedQuantity }]
   */
  returnMaterial(id, lines) {
    return ApiService.post(`${BASE_URL}/${id}/return`, { lines });
  },

  /**
   * Huỷ MRQ thủ công — chỉ khi PENDING (AC-05).
   * @param {string} id
   */
  cancel(id) {
    return ApiService.post(`${BASE_URL}/${id}/cancel`, {});
  },
};

export default MaterialRequisitionService;
